import { useState, useEffect } from 'react'
import enContent from '../content/en.json'
import mkContent from '../content/mk.json'

export const useLanguage = () => {
  const [language, setLanguage] = useState('en')
  const [content, setContent] = useState(enContent)

  useEffect(() => {
    const savedLanguage = localStorage.getItem('makemyday-language')
    if (savedLanguage) {
      setLanguage(savedLanguage)
      setContent(savedLanguage === 'en' ? enContent : mkContent)
    }
  }, [])

  const changeLanguage = (lang: string) => {
    setLanguage(lang)
    setContent(lang === 'en' ? enContent : mkContent)
    localStorage.setItem('makemyday-language', lang)
  }

  return {
    language,
    setLanguage: changeLanguage,
    content
  }
} 